export const OperationsQueryKeys = {
  all: ["operations"] as const,
  findAllMissions: () => [...OperationsQueryKeys.all, "missions"] as const,
};
